export default "__VITE_ASSET__Bn9EG6xF__"